import type { PageContent } from "../types";

export const p_bert_expansion_and_passage_indexing: PageContent = {
  slug: "bert-expansion-and-passage-indexing",
  title: `BERT Expansion and Passage Indexing | Phil Carr SEO Consultant`,
  description: `By 2020, Google’s BERT algorithm—originally introduced in 2019 to better understand natural language—expanded to nearly all English queries. BERT helps Google grasp the context and…`,
  date: "",
  lastUpdated: "2026-05-19",
  body: `# BERT Expansion and Passage Indexing

![BERT Expansion and Passage Indexing featured image](/images/blog/generated/bert-expansion-and-passage-indexing.jpg)

**Published:** June 15, 2020

## Expanding BERT to More Queries

By 2020, Google’s BERT algorithm—originally introduced in 2019 to better understand natural language—expanded to nearly all English queries. BERT helps Google grasp the context and nuances of words within a sentence, leading to more relevant results for complex queries.

This expansion meant that content written in clear, conversational language saw improved performance, while awkward, keyword‑heavy writing fell behind.

## Passage Indexing Unveiled

Google also announced the concept of passage indexing, later called passage ranking. Instead of evaluating entire pages as a whole, the algorithm could rank specific sections that answer queries, even if the rest of the page covers different topics.

This allowed long‑form content to be more competitive if it contained well‑structured answers to niche questions.

## Content Strategy Implications

To optimise for BERT and passage indexing, write in a natural, human tone. Avoid forcing keywords into sentences where they don’t fit.

Break up your content into logical sections with descriptive subheadings so search engines can easily identify relevant passages. When answering a question, provide the answer near the top of the section and then offer supporting details.

This makes it easier for search engines to pull the answer into featured snippets or top‑ranked passages.

## SEO Takeaways and Next Steps

BERT expansion and passage indexing pushed SEO further toward quality writing and thoughtful organisation. If you need guidance on creating content that resonates with both readers and algorithms, contact me at info@phil‑carr.co.uk or 01226 697 325.

If you need help with your SEO strategy, get in touch by emailing [info@phil-carr.co.uk](mailto:info@phil-carr.co.uk) or calling 01226 697 325.

## Key Takeaways

- **Expanding BERT to More Queries:** By 2020, Google’s BERT algorithm—originally introduced in 2019 to better understand natural language—expanded to nearly all English queries.
- **Passage Indexing Unveiled:** Google also announced the concept of passage indexing, later called passage ranking.
- **Content Strategy Implications:** To optimise for BERT and passage indexing, write in a natural, human tone.

## Update — May 2026

Refreshed in May 2026 to reflect how AI Overviews now show for a wider share of informational queries in the UK. The tactics below still apply — clear question-and-answer structure and strong entity signals — but the citation share has shifted toward brands with visible expertise pages.

## About the author

Phil Carr is an SEO consultant and web strategist focused on helping businesses
grow through technical optimisation, content strategy, and data-driven decision making. His
work combines hands-on experience with ongoing research into algorithm updates and emerging
search trends.

[Read Phil’s bio](/#authorModal)

## Other News Articles

[![2024 Algorithm Updates – Navigating a Year of Core Changes and Spam Crackdowns featured image](/images/blog/generated/2024-algorithm-updates-navigating-a-year-of-core-changes-and-spam-crackdowns.jpg)](/blog/2024-algorithm-updates-navigating-a-year-of-core-changes-and-spam-crackdowns)

### [2024 Algorithm Updates – Navigating a Year of Core Changes and Spam Crackdowns](/blog/2024-algorithm-updates-navigating-a-year-of-core-changes-and-spam-crackdowns)

[![2023 SEO Lessons and Forward View featured image](/images/blog/generated/2023-seo-lessons-and-forward-view.jpg)](/blog/2023-seo-lessons-and-forward-view)

### [2023 SEO Lessons and Forward View](/blog/2023-seo-lessons-and-forward-view)

[![A Practical Plan for AI-Driven Search – A Ninety Day Playbook featured image](/images/blog/generated/a-practical-plan-for-ai-driven-search-a-ninety-day-playbook.jpg)](/blog/a-practical-plan-for-ai-driven-search-a-ninety-day-playbook)

### [A Practical Plan for AI-Driven Search – A Ninety Day Playbook](/blog/a-practical-plan-for-ai-driven-search-a-ninety-day-playbook)

[![Looking Ahead: Lessons from 2024 for the Future featured image](/images/blog/generated/looking-ahead-lessons-from-2024-for-the-future.jpg)](/blog/looking-ahead-lessons-from-2024-for-the-future)

### [Looking Ahead: Lessons from 2024 for the Future](/blog/looking-ahead-lessons-from-2024-for-the-future)

We use cookies to improve your experience, analyse site traffic, and understand how you interact with
our content. Read our [cookie policy](/cookies) to learn more.

Reject optionalAccept cookies [Privacy policy](/privacy-policy)

reCAPTCHA

Recaptcha requires verification.

protected by **reCAPTCHA**`,
};
